export default "__VITE_ASSET__BWkg4LrH__"